import React from 'react'
import { Tag, Button, Space } from 'antd'
import moment from 'moment'
import {
  STATUS_COLORS,
  STATUS_LABELS,
  STATUSES,
  TERMINAL_STATUSES,
  CANCELLABLE_STATUSES,
  SURPRISE_BOX_DATE_TIME_FORMAT,
} from './constants'

const formatDateTime = (value) =>
  value ? moment.utc(value).local().format(SURPRISE_BOX_DATE_TIME_FORMAT) : '-'

const formatMoney = (value) =>
  value === null || value === undefined ? '-' : `$${Number(value).toFixed(2)}`

const noWrapHeader = () => ({ style: { whiteSpace: 'nowrap' } })

export const getColumns = ({ onView, onEdit, onActivate, onCancel }) => [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 80, onHeaderCell: noWrapHeader },
  { title: 'Name', dataIndex: 'name', key: 'name', ellipsis: true, onHeaderCell: noWrapHeader },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 170,
    onHeaderCell: noWrapHeader,
    render: (status) => (
      <Tag color={STATUS_COLORS[status] || 'default'}>
        {STATUS_LABELS[status] || status}
      </Tag>
    ),
  },
  {
    title: 'Ticket Price',
    dataIndex: 'ticket_price',
    key: 'ticket_price',
    width: 130,
    onHeaderCell: noWrapHeader,
    render: formatMoney,
  },
  {
    title: 'Prize Value',
    dataIndex: 'prize_value',
    key: 'prize_value',
    width: 130,
    onHeaderCell: noWrapHeader,
    render: formatMoney,
  },
  {
    title: 'Tickets Sold',
    key: 'tickets_sold',
    width: 130,
    onHeaderCell: noWrapHeader,
    render: (_, record) => record?.summary?.tickets_sold ?? 0,
  },
  {
    title: 'Start',
    dataIndex: 'promotion_start_time',
    key: 'promotion_start_time',
    width: 160,
    onHeaderCell: noWrapHeader,
    render: formatDateTime,
  },
  {
    title: 'Sales Close',
    dataIndex: 'sales_close_time',
    key: 'sales_close_time',
    width: 160,
    onHeaderCell: noWrapHeader,
    render: formatDateTime,
  },
  {
    title: 'Prize Draw Time',
    dataIndex: 'draw_time',
    key: 'draw_time',
    width: 180,
    onHeaderCell: noWrapHeader,
    render: formatDateTime,
  },
  {
    title: 'Prize Drawn At',
    dataIndex: 'drawn_at',
    key: 'drawn_at',
    width: 180,
    onHeaderCell: noWrapHeader,
    render: formatDateTime,
  },
  {
    title: 'Winner Ticket',
    dataIndex: 'winner_ticket_id',
    key: 'winner_ticket_id',
    width: 140,
    onHeaderCell: noWrapHeader,
    render: (id) => id || '-',
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 320,
    fixed: 'right',
    onHeaderCell: noWrapHeader,
    render: (_, record) => {
      const isTerminal = TERMINAL_STATUSES.includes(record.status)
      const isClosed = record.status === STATUSES.CLOSED
      const isDraft = record.status === STATUSES.DRAFT
      const canEdit = !isTerminal && !isClosed
      const canCancel = CANCELLABLE_STATUSES.includes(record.status)

      return (
        <Space size={4} wrap>
          <Button size="small" onClick={() => onView(record)}>View</Button>
          {canEdit && (
            <Button size="small" onClick={() => onEdit(record)}>Edit</Button>
          )}
          {isDraft && (
            <Button size="small" type="primary" onClick={() => onActivate(record)}>
              Activate
            </Button>
          )}
          {canCancel && (
            <Button size="small" danger onClick={() => onCancel(record)}>
              Cancel
            </Button>
          )}
        </Space>
      )
    },
  },
]
